/**
 * Created by mauget on 1/23/16.
 */

// BehaviorsPageView.js

import $            from 'jquery';
import _            from 'lodash';
import Immutable    from 'immutable';
import fabric               from 'fabric.js/dist/fabric.require.js';
import connectionController from 'ConnectionController.js';
import crudController       from 'CrudController.js';
import factoryService       from 'FactoryService.js';
import dragDropService      from 'DragDropService.js';
import constants            from 'Constants.js';
import focusController      from 'FocusController.js';
import listService          from 'ListService.js';
import undoService          from 'UndoService';
import AttributesView       from 'properties/AttributesView.js'
import TabSettingsView      from 'behaviors/properties/TabSettingsView.js';
import TabSummaryView       from 'behaviors/properties/TabSummaryView.js';
import eventBus             from 'EventBus.js';
import BaseGraphicsPageView from 'form/BaseGraphicsPageView.js';
import { ConnectionArrowClass } from 'shapelib/ConnectionArrowClass.js';
import { TooltipClass }     from 'shapelib/TooltipClass.js';
import util                 from 'util/Util.js';
import textConstants        from 'TextConstants';
import template             from 'form/graphic-page.ejs';
import objectUtil           from 'util/ObjectUtil.js';
import widgetUtil           from 'util/WidgetUtil';
import behaviorHelperService    from 'BehaviorHelperService.js';

const MARGINFIX = 14;
const TOOLTIP_WIDTH = 350;
const MIN_CONTROL_WIDTH = 111;
const MIN_CONTROL_HEIGHT = 41;
//==========================================================================================
// A BackBone view of a PerfectForms layout Fabric.js canvas-based page.
// Lou Mauget, January 23, 2015
//==========================================================================================
class BehaviorsPageView extends BaseGraphicsPageView {


    initialize(opts = {}) {
        this.options = opts || {};

        this.listenTo(eventBus, 'resizeBehaviorCanvas', this.resizeCanvas);
        this.listenTo(eventBus, 'redrawBehaviorGrid', this.drawGrid);
        this.listenTo( eventBus, constants.EV_BEHAVIOR_PROPERTY_CHANGED, this.cleanAndRenderBehaviorProperties);
        this.listenTo( eventBus, 'selectSingleItemFromCanvas', this.triggerItemSelection);
        this.listenTo( eventBus, 'showInstanceInformation', this.switchProperties);
        this.listenTo(eventBus, 'selectBehaviorConnection', this.selectConnectionArrow);

            setTimeout(() => {
                // Display behavior instance properties
                const instance = listService.getBehaviorInstance(listService._currentBehaviorInstanceId);
                this.switchProperties(instance);
                listService.currentBehaviorId = '';
                listService.fcanvas.renderAll();
                util.updateHelpDocumentationLink('behavior');
                if (listService.itemSearched !== 0) {
                    const selectedObject = listService.getCanvasObjectById(listService.itemSearched);
                    listService.fcanvas.setActiveObject(selectedObject).renderAll();
                    this.triggerItemSelection();

                    listService.itemSearched = 0;
                }
                //Remove parsed Item so this instance can be processed on save
                if (typeof instance !== 'undefined'){
                    listService.unsetPageOriginalItems(instance.get('pageId'));
                    if (typeof instance.get('parsedItem') !== 'undefined'){
                        instance.unset('parsedItem');
                    }
                }

            }, 200);
        return this;
    }

    triggerItemSelection() {
        this.switchProperties(listService.fcanvas.getActiveObject().model);
    }

    // DRY. Maybe refactor these props to a common place? These duplicated in MobileDragDropService.js
    //==========================================================================================
    // Property: Perfect Forms canvas page position within DOM window
    //==========================================================================================
    get pagePos() {
        const offset = $(constants.PAGESEL_ID).offset();
        return {
            top: offset.top - $(window).scrollTop(),
            left: offset.left - $(window).scrollLeft()
        };
    }


    //==========================================================================================
    // Property: Perfect Forms canvas page width and height
    //==========================================================================================
    get pageDim() {
        return {
            width: $(constants.PAGESEL_ID).width(),
            height: $(constants.PAGESEL_ID).height()
        };
    }


    //==========================================================================================
    // Property: Perfect Forms canvas page rectangle in offset coordinates compensated for
    // window scroll position.
    //==========================================================================================
    get pageRect() {
        return {
            top: this.pagePos.top,
            left: this.pagePos.left,
            height: this.pageDim.height,
            width: this.pageDim.width
        };
    }


    setCanvas(rawId, width, height) {
        const c = $(constants.ID_SEL + rawId);
        const ctx = c[0].getContext('2d');

        // set width and height
        ctx.canvas.width = width;
        ctx.canvas.height = height;

        let fcanvas = listService.fcanvas;
        if (fcanvas) {
            fcanvas.setWidth(width);
            fcanvas.setHeight(height);
            fcanvas.calcOffset();

            $('.canvas-container').css({'width': width, 'height': height});
        }

        return ctx;
    }

    //===============================================================================
    // The context width / height settings are the means to size an HTML5 canvas.
    //===============================================================================
    resizeCanvas(rawId, width, height) {
        const c = $(constants.ID_SEL + rawId);
        const ctx = c[0].getContext('2d');

        this.model.set('width', width, constants.MODEL_SILENT);
        this.model.set('height', height, constants.MODEL_SILENT);

        // set Behavior Instance Model
        if (listService._currentBehaviorInstanceId) {
            const instance = listService.getBehaviorInstance(listService._currentBehaviorInstanceId);
            instance.set('width', width, constants.MODEL_SILENT);
            instance.set('height', height, constants.MODEL_SILENT);
        }

        // set width and height
        ctx.canvas.width = width;
        ctx.canvas.height = height;


        const fcanvas = listService.fcanvas;
        if (fcanvas) {
            fcanvas.setWidth(width);
            fcanvas.setHeight(height);
            fcanvas.calcOffset();

            $('.canvas-container').css({'width': width, 'height': height});

            // Replaces the grid and background
            this.drawGrid();
        }

        return ctx;
    }


    // TODO: Pull this listener up to BaseGraphicsPageView -- duplicated between workflow and behaviors
    //==========================================================================
    // Paints a grid on a second, bottom, static canvas.
    // This separate canvas approach prevents gridlines from obscuring active
    // shapes and paths: they're in a separate layer.
    //==========================================================================
    drawGrid() {
        const
            fcanvas = listService.fcanvas,
            width = fcanvas.width,
            height = fcanvas.height,
            gridSize = this.model.attributes.gridWidth;

        const gridCanvas = new fabric.StaticCanvas(constants.GRID_CANVAS_RAW_ID,
            {
                backgroundColor: constants.BEH_BG_CLR,  // Picked from AS version
                width: width,
                height: height,
                selection: false,
                renderOnAddRemove: false
            });

        const strokeStyle = constants.BEH_GRIDLINE_CLR;

        for (let x = gridSize; x < width; x += gridSize) {
            gridCanvas.add(new fabric.Line([0, 0, 0, height], {
                left: x,
                top: 0,
                stroke: strokeStyle,
                selectable: false,
                hasControls : false,
                hasRotatingPoint: false,
                hasBorders: false
            }));
        }

        for (let y = gridSize; y < height; y += gridSize) {
            gridCanvas.add(new fabric.Line([0, 0, width, 0], {
                left: 0,
                top: y,
                stroke: strokeStyle,
                selectable: false,
                hasControls : false,
                hasRotatingPoint: false,
                hasBorders: false
            }));
        }

        gridCanvas.renderAll();
    }


    // TODO: Pull this listener up to BaseGraphicsPageView -- duplicated between workflow and behaviors
    //==========================================================================
    // Create fabric.js canvas wrapper for properly sized HTML canvas.
    // Draw the grid on the fabric canvas.
    //==========================================================================
    createFabricCanvas(rawCanvasId) {
        // create a wrapper around native canvas element (by id )
        const transparentColor = 'rgba(0, 0, 0, 0.0)';
        listService.fcanvas = new fabric.Canvas(rawCanvasId, {
                backgroundColor: transparentColor,
                selectionColor: 'rgba(100, 100, 100, 0.3)',
                renderOnAddRemove: false,
                selectionLineWidth: 1
            }
        );

        // PF-9399 add flag to avoid calling showHiddenBehaviors method more than once time during scroll 
        const aFormAux = document.getElementById('aForm');
        aFormAux.setAttribute('showHiddenBehaviors', 'false');

        // Add a scroll listener, so we can make visible hidden behaviors
        fabric.util.addListener(aFormAux, 'scroll', function () {
            
            // PF-9399
            // Call showHiddenBehaviors only when attribute is false
            if(aFormAux.getAttribute('showHiddenBehaviors') === 'false') {
                // Set to true to avoid run again the same method
                aFormAux.setAttribute('showHiddenBehaviors', 'true');

                behaviorHelperService.showHiddenBehaviors();
                // Wait 100 ms to set flag to false
                setTimeout(() => {
                    aFormAux.setAttribute('showHiddenBehaviors', 'false');
                }, 100);
            }
           
        });
        return listService.fcanvas;
    }

    //==========================================================================
    // For Behaviors = fabricjs canvas:
    // Start specialized listeners that operate outside of BackBone.
    // They act together  to implement drag/drop/focus behaviors on the page.
    //==========================================================================
    startBehaviorsPageListeners(canvas2Id) {
        dragDropService.listenForDropBehaviors(canvas2Id);
        dragDropService.listenForFactoryDragStartBehaviors(factoryService.behaviorsFactories);
        dragDropService.listenForDragEnd(constants.CONTENT_ID);
        focusController.startControlFocusListeners($(canvas2Id));

    }


    //==========================================================================
    // Initial behaviors canvas layout size is that of form. Make it so.
    //==========================================================================
    measureForm(formId) {
        const $formId = $(formId);
        const result = {width: $formId.width(), height: $formId.height()}
        return result;
    }

    isValidBehaviorObject( obj ) {
        return obj.target.model && obj.target.model.get('factoryKey') !== 'connection_arrow';
    }

    isBranch(view) {
        const key = 'factoryKey';
        return view && view.model &&
            ( view.model.get(key) === 'command_simple_branch' ||
                view.model.get(key) ==='command_multiple_branch' );
    }

    fnGenDeltaPoint(fc, d) {
        return {dx: fc === 'left' ? d : 0, dy: fc === 'top' ? d : 0} ;
    }

    //==========================================================================
    // Initializes the behaviors canvas. Unlike the layout canvas, we draw
    // widgets on it.
    //==========================================================================
    initCanvas() {

        this.dim = {height: 900, width: 700};

        const bottom_margin = 30;
        const right_margin = 4;
        const locked = true;

        // Set size of native canvas
        const canvasRawId = 'aPageSel';
        const ctx = this.setCanvas(canvasRawId, this.dim.width, this.dim.height);
        const fcanvas = this.createFabricCanvas(canvasRawId);
        fcanvas.perPixelTargetFind = true;
        fcanvas.targetFindTolerance = constants.CONNECTION_LINE_TOLERANCE;

        const that = this;
        let scaling = false;

        // Set the click event so that the widgets can be selected and the Properties can be rendered.
        fcanvas.off('mouse:down');
        fcanvas.on('mouse:down', option => {
            // PF-3892: Show available edit menu options
            listService.countingValidObjects();
            util.validateMenuItems( listService.selectedCount );

            if (option.target && option.target.type === 'group') {
                const obj = option.target;
                if (!obj.model) {
                    return;
                }

                widgetUtil.removeAllBezeierControlPoints();
                listService.currentSelectedPathId = undefined;

                // Cache current position of PerfectForms widget custom property
                obj.prevPos = {'left': obj.left, 'top': obj.top};

            }else if (option.target && option.target.type === 'ConnectionArrow') {
                this.selectConnectionArrow(option.target);
            }
            else if (!option.target) {

                //PF-5194 One last check because in curved line sometimes the click is not
                //identified, the checkAllObjectsIfHit function is used to check if the click happened on a curved line
                widgetUtil.checkAllObjectsIfHit(option);

                if (!option.target) {
                    widgetUtil.removeAllBezeierControlPoints();
                    listService.currentSelectedPathId = undefined;
                    // get current Instance
                    const instance = listService.getBehaviorInstance(listService._currentBehaviorInstanceId);

                    //If option Undo New Behavior was selected "instance" doesn't exist anymore and we need to clean views
                    if (instance) {
                        if (instance.get('ownerId') === 'Form') {
                            instance.set('pageId', '', { silent: true });
                        }
                        that.switchProperties(instance);
                    } else {
                        if (this._subviews) {
                            this._subviews.map(pview => {
                                pview.clearPropertyViews();
                            });
                        }
                    }

                    // PF-4075 Initializing behavior selection once canvas group is deselected.
                    _.forEach(listService._behaviorObjMap.toArray(), behavior => {
                        behavior.model.set('selected', false, { silent: true });
                    });

                    listService.currentBehaviorId = '';
                    listService.fcanvas.renderAll();
                    util.updateHelpDocumentationLink('behavior');
                }
            }
        });

        fcanvas.off('mouse:up');
        fcanvas.on('mouse:up', option => {
            let keyboardMove = option.e && option.e.keyboardMove? option.e.keyboardMove : false;
            if (option.target && option.target.type === 'group') {
                const obj = option.target;
                switch (option.target.type) {
                    case 'ConnectionArrow':
                        this.selectConnectionArrow(obj);
                        break;
                    case 'group':
                        const fcanvas = listService.fcanvas;
                        const self = this;
                        let movedControls = [],
                            movedControlsAfter = [];

                        let activeObject = fcanvas.getActiveObject(),
                            activeGroup = fcanvas.getActiveGroup();

                        // PF-4009 Context menu disappears if any object selected during right-click
                        if (activeObject && option.e.button !== 2 && !keyboardMove) {
                            that.switchProperties(activeObject.model);
                            objectUtil.selectCanvas(activeObject);
                        }

                        if (obj.model && (!activeGroup)) {
                            const oldX = obj.model.get('x');
                            const oldY = obj.model.get('y');

                            const targetLeft = option.target.left < 0 ? option.target.left * -1 : option.target.left;
                            const targetTop = option.target.top < 0 ? option.target.top * -1 : option.target.top;

                            if (obj.model && (!activeGroup)) {
                                const oldX = obj.model.get('x');
                                const oldY = obj.model.get('y');

                                const targetLeft = option.target.left < 0 ? option.target.left * -1 : option.target.left;
                                const targetTop = option.target.top < 0 ? option.target.top * -1 : option.target.top;


                                if (oldX === option.target.left && oldY === option.target.top && !keyboardMove) {
                                    return; // don't record a move if it was just clicked, not moved.
                                }

                                if (option.target.model.get('factoryKey') === 'command_comment'
                                    && option.target.originalState.left === option.target.left
                                    && option.target.originalState.top === option.target.top) {
                                    return;
                                }

                                movedControls.push({
                                    id: obj.model.get('id'),
                                    y: obj.model.get('y'),
                                    x: obj.model.get('x'),
                                    width: obj.model.get('width'),
                                    height: obj.model.get('height'),
                                    factoryKey: obj.model.get('factoryKey')
                                });
                                obj.model.set({ 'y': targetTop, 'x': targetLeft }, constants.MODEL_SILENT);
                                movedControlsAfter.push({
                                    id: obj.model.get('id'),
                                    y: obj.model.get('y'),
                                    x: obj.model.get('x'),
                                    width: obj.model.get('width'),
                                    height: obj.model.get('height'),
                                    factoryKey: obj.model.get('factoryKey')
                                });

                                // check if out of bounds
                                this.checkObjectLocation(fcanvas, option.target.top, option.target.left, obj.model, undefined, activeObject);

                                undoService.add({
                                    undo: () => {
                                        self._processMovedControls(movedControls, []);
                                    },
                                    redo: () => {
                                        self._processMovedControls(movedControlsAfter, []);
                                    }
                                }, textConstants.UNDO_MOVE);
                            }
                        }

                            if (activeGroup) {
                                let movedControls = [],
                                    movedControlsAfter = [],
                                    skipMove = false;

                                let grpLeft = activeGroup.left < 0 ? activeGroup.left * -1 : activeGroup.left;
                                let grpTop = activeGroup.top < 0 ? activeGroup.top * -1 : activeGroup.top;
                                const grpWidth = activeGroup.width;
                                const grpHeight = activeGroup.height;
                                const adjustIncreaseOfGrp = 4;

                                _.forEach(activeGroup._objects.filter(w => w.model), function (obj) {
                                    const left = (grpWidth / 2) + obj.left + grpLeft - adjustIncreaseOfGrp;
                                    const top = (grpHeight / 2) + obj.top + grpTop - adjustIncreaseOfGrp;

                                    const oldX = obj.model.get('x');
                                    const oldY = obj.model.get('y');

                                    if (oldX === left && oldY === top) {
                                        skipMove = true;
                                        return; // don't record a move if it was just clicked, not moved.
                                    }

                                    movedControls.push({
                                        id: obj.model.get('id'),
                                        y: obj.model.get('y'),
                                        x: obj.model.get('x'),
                                        width: obj.model.get('width'),
                                        height: obj.model.get('height'),
                                        factoryKey: obj.model.get('factoryKey')
                                    });
                                    obj.model.set({ 'y': top, 'x': left }, constants.MODEL_SILENT);
                                    if (obj.model.get('factoryKey') !== 'connection_arrow') {
                                        obj.model.resetLastState();
                                    }
                                    movedControlsAfter.push({
                                        id: obj.model.get('id'),
                                        y: obj.model.get('y'),
                                        x: obj.model.get('x'),
                                        width: obj.model.get('width'),
                                        height: obj.model.get('height'),
                                        factoryKey: obj.model.get('factoryKey')
                                    });
                                });
                                this.checkObjectLocation(fcanvas, 0, 0, obj.model, activeGroup, activeGroup);


                                if (!skipMove) {
                                    undoService.add({
                                        undo: () => {
                                            self._processMovedControls(movedControls, activeGroup);
                                        },
                                        redo: () => {
                                            self._processMovedControls(movedControlsAfter, activeGroup);
                                        }
                                    }, textConstants.UNDO_MOVE);
                                }
                            }
                        break;
                }
            }

            const activeGroup = listService.fcanvas.getActiveGroup();
            if (activeGroup) {
                let section = listService.docType.toString();
                let helpLink = section.indexOf('form') > -1? 'behavior_form_group' : 'behavior_report_group';
                util.updateHelpDocumentationLink(helpLink);
            }
        });

        fcanvas.off('object:selected');
        fcanvas.on('object:selected', option => {
            objectUtil.checkCtrlSelection(option,listService._behaviorObjMap.toArray());

            //  Fabric Js was modified on method _shouldGroup in order to avoid the shift key selection
            // Path / connection selection logic handled elsewhere. All other widgets pass through here ..
            if (option.target && option.target.type !== 'ConnectionArrow') {
                //If multi-select is used return null if only one item was selected properties need to be shown
                const activeObject = fcanvas.getActiveObject(),
                    adjustedScale = MIN_CONTROL_WIDTH/option.target.width;

                if ( fcanvas.getActiveGroup() ) {
                    option.target.hasControls = false;
                } else {
                    if (option.target.model && option.target.model.get('factoryKey') === 'command_comment') {
                        option.target.minScaleLimit = adjustedScale;
                        option.target.lockScalingFlip = true;
                        option.target.hasControls  = true;
                    }
                }

                function selectingOnlyConnectors(target) {
                    let result = false;
                    if (target._objects && target._objects.length === 2) {
                        let onlyArrows = true;
                        _.forEach(target._objects, function (obj) {
                            if (obj.model.attributes.factoryKey !== 'connection_arrow') {
                                onlyArrows = false;
                            }
                        });
                        if (onlyArrows) {
                            result = true;
                        }
                    }
                    return result;
                }


                // Note: if you receive a ticket wanting drag-selection of a single connection, then move this call to follow the if(activeObject) below
                this.evictConnectionsFromMultiSelection(fcanvas);

                if (activeObject) {
                    if (selectingOnlyConnectors(option.target)) {
                        // avoid selecting only connectors
                        listService.fcanvas.discardActiveObject();
                        listService.fcanvas.discardActiveGroup();
                        listService.fcanvas.renderAll();
                    } else {

                        // No model at this point, if paste
                        if (activeObject.model) {
                            if (activeObject.model.get('factoryKey') === 'connection_arrow') {
                                this.selectConnectionArrow(activeObject);
                            }
                            else {
                                util.updateHelpDocumentationLink(activeObject.model.get('factoryKey'));
                            }

                            if (!option.e){ //switch properties only if it is command creation

                                let shouldEnter = option.target.model && option.target.model.get('isNewInstance');
                                if (!shouldEnter) {
                                    that.switchProperties(activeObject.model, false);
                                }
                            }
                        }
                    }
                }
            } else {
                // PF-2345 Kill any prior red dots
                widgetUtil.removeAllBezeierControlPoints();
            }
            // Note: if you receive a ticket wanting drag-selection of a single connection, then enable this call after removing the call prior to if(activeOejct)
            // this.evictConnectionsFromMultiSelection(fcanvas);

            // PF-2320: Show available menu options
            listService.countingValidObjects();
            util.validateMenuItems(listService.selectedCount);

        });

        fcanvas.off('mouse:move');
        fcanvas.on('mouse:move', function(option) {
            if (!option.target) {
                $('input').trigger('blur');
                $('textarea').trigger('blur');
            }
        });

        // PF-2320: Bring to front the hovered stage
        fcanvas.off('mouse:over');
        fcanvas.on('mouse:over', function(e) {
            const obj = e.target,
                canvasWidth = listService.fcanvas.getWidth();
            if ( that.isValidBehaviorObject(e) ) {
                e.target.bringToFront();
            }
            if (obj.model && obj.model.get('factoryKey') !== 'connection_arrow') {
                if (obj.item(0).textOverflown) {
                    const entireText = obj.model.get('factoryKey') === 'command_comment'
                        ? obj.model.get('text')
                        : obj.model.get('widgetText');

                    listService.fcanvas.add(new TooltipClass(entireText, obj, TOOLTIP_WIDTH, canvasWidth));
                }

            }
        });

        fcanvas.off('mouse:out');
        fcanvas.on('mouse:out', function(e) {
            if (!e.hasOwnProperty('drawing')) {
                let objecstToDelete = [];

                listService.fcanvas.getObjects().forEach(o=>{
                    if (o.isTooltip) {
                        objecstToDelete.push(o);
                    }
                });

                for (let i=0 ; i<=objecstToDelete.length ; i++) {
                    listService.fcanvas.remove(objecstToDelete[i]);
                }
            }
        });

        fcanvas.off('object:scaling');
        fcanvas.on({'object:scaling': function(e){
            that.scaling = true;
            const obj = e.target;
            const scaleX = obj.get('scaleX') > 0 ? obj.get('scaleX') : 0.0001;
            const scaleY = obj.get('scaleY') > 0 ? obj.get('scaleY') : 0.0001;
            obj.item(0).set({
                width: obj.get('width')*scaleX,
                height: obj.get('height')*scaleY,
                scaleX: 1/scaleX,
                scaleY: 1/scaleY
            });

        }});

        fcanvas.off('object:modified');
        fcanvas.on('object:modified', function(e){

            if (that.scaling) {

                let obj = e.target,
                    scale = {x:obj.scaleX, y:obj.scaleY},
                    newDim = {
                        x: obj.width*scale.x > MIN_CONTROL_WIDTH ? obj.width*scale.x :MIN_CONTROL_WIDTH,
                        y: obj.height*scale.y > MIN_CONTROL_HEIGHT ? obj.height*scale.y : MIN_CONTROL_HEIGHT
                    };

                const activeObject = listService.fcanvas.getActiveObject();
                if (activeObject) {
                    activeObject.model.set({'width': newDim.x - MARGINFIX, 'height': newDim.y - MARGINFIX}, constants.MODEL_SILENT);
                    listService.fcanvas.renderAll();
                }

                that.scaling = false;
            }
        })

        // Adding double click mouse event when fabricJS will be updated this event will be native
        fabric.util.addListener(fcanvas.upperCanvasEl, 'dblclick', function(e) {
            if (fcanvas.findTarget(e) && e.ctrlKey ) {
                const obj = fcanvas.findTarget(e);
                if(obj.model.get('factoryKey') === 'command_run' && obj.model.get('scriptId')){
                    const instance = listService.getBehaviorInstance(listService.cleanId(obj.model.get('scriptId')));

                    if(instance && instance.get('ownerId') && instance.get('behaviorKey')){

                      // PF-1951 Turning on flag for back-button purposes
                      listService.linkClicked = true;
                      Backbone.history.loadUrl(`behaviors/${instance.get('ownerId')}/${instance.get('behaviorKey')}`);
                      listService.clearSelected();
                   }
                }
            }
        });

        // Init sticky connection support
        super.supportStickyConnections(fcanvas);

        this.startBehaviorsPageListeners(constants.UPPER_CANVAS_CLS);
        connectionController.runStateMachine(fcanvas, true);

        return this;
    }

    selectConnectionArrow(w) {
        // Preventing the movement of a connection arrow
        w.lockMovementX = true;
        w.lockMovementY = true;

        listService.currentSelectedPathId = w.model.get('id');
        util.updateHelpDocumentationLink('connection_arrow_behavior');
        this.switchProperties(w.model);
    }

    _processMovedControls(controls, activeGroup) {
        const self = this;
        const fcanvas = listService.fcanvas;
        const locked = true;

        _.forEach(controls, function (c) {

            if (c.factoryKey === 'connection_arrow') {

                const connection = listService.getBehaviorConnection(c.id);
                connection.model.set(c, constants.MODEL_SILENT);


                const cinfo = util.getCommandCoordInfo(connection);
                const opts = constants.LINE_MODEL_OPTIONS;
                opts.model = connection.model;
                const line = new ConnectionArrowClass(cinfo.coords, opts);

                listService.fcanvas.remove(connection.line);

                if (listService.mainKind === constants.KIND_BEHAVIORS) {
                    listService.fcanvas.add(line);
                }
                self.updateConnectionLineOnObject(line, connection);

            } else {
                const beh = listService.getBehaviorObject(c.id);
                const oldX = beh.model.get('x');
                const oldY = beh.model.get('y');
                beh.model.set(c, constants.MODEL_SILENT);
                beh.model.resetLastState();
                beh.rerender();
                connectionController.updateConnection(beh.model, {x1: beh.model.get('x'),
                    x2: oldX,
                    y1: beh.model.get('y'),
                    y2: oldY});
            }
        });

        _.forEach(activeGroup._objects, function (obj) {
            fcanvas.remove(obj);
            //activeGroup.removeWithUpdate(obj);
        });
        fcanvas.discardActiveGroup();
        fcanvas.renderAll();
    }

    switchProperties(behaviorModel, switchSettingsTab = true) {


            // add delay here so the current properties have time to fire their events before switching.
            focusController.clearAllSelected();

        // Proceed only if a behavior was ever selected in this session:
        if (behaviorModel) {

            // PF-3087: Highlight thumbnail menu
            const $behaviorLabel = (behaviorModel.get('owner') === 'Form')
                ? util.jqId('behaviors-forms')
                : util.jqId(`behaviors-page-${listService.currentPageId}`);

            $behaviorLabel.find(`li[data-id="${behaviorModel.attributes.id}"]`).addClass('controlSelected');
            // PF-3087: Highlight thumbnail menu
            if(behaviorModel){
                let $behaviorLabel = (behaviorModel.get('owner') === 'Form')
                    ? util.jqId('behaviors-forms')
                    : util.jqId(`behaviors-page-${listService.currentPageId}`);

                $behaviorLabel.find(`li[data-id="${behaviorModel.attributes.id}"]`).addClass('controlSelected');

            }
            listService.objectList.map(view => {
                if (view.subviews) {
                    view.subviews.map((propertyView) => {
                        propertyView.undelegateEvents();
                    });
                }
            });

            if (this._subviews) {
                this._subviews.map(pview => {
                    pview.clearPropertyViews();
                });
            }

            this._subviews = Immutable.Map()
                .set('attributesView', new AttributesView({model: behaviorModel, el: $(constants.PROP_ATTRIBUTES_ID)}))
                .set('summaryView', new TabSummaryView({model: behaviorModel, el: $(constants.PROP_TAB_SUMMARY_ID)}))
                .set('settingsView', new TabSettingsView({model: behaviorModel, el: $(constants.PROP_SETTNGS_ID)}));

            if (this._subviews) {
                this.delegateEvents();
                this._subviews.map(pview => {
                    pview.render();
                    pview.delegateEvents();
                });
            }

            setTimeout(() => {
                $('#settings-tab a').click();
            }, 100);

        }
            if (switchSettingsTab) {
                setTimeout(() => {
                    $('#settings-tab a').click();
                }, 100);
            }
    }

    deleteSelectedBehaviors(ev) {
        // Listening for KeyUp Events and deleting selected behaviors.
        if (ev.keyCode === 46) {
            crudController.deleteSelectedBehaviors();
        }
    }

    cleanAndRenderBehaviorProperties(model){
        this.switchProperties(model);
    }

    isCurvedPathHit(ev){

    }

    //==========================================================================
    // Implements standard BackBone View render method.
    //
    //==========================================================================
    render() {
        this.$el.html( template(this.model.toJSON()) );
        this.initCanvas();
        this.delegateEvents();
        
        /*
        AAE-TODO: might worth do this part
        listService.fcanvas.getObjects().forEach(item=>{
            console.log( item.model.get('factoryKey'), item.model.get('active') );
            item.model.set('active', false);
        });
        */

        setTimeout(()=>{
            if (listService.itemSearched !== 0) {
                const selectedObject = listService.getCanvasObjectById(listService.itemSearched);
                if (selectedObject) {
                    listService.fcanvas.setActiveObject(selectedObject).renderAll();
                    selectedObject.model.set('active', true);
                    eventBus.trigger('selectSingleItemFromCanvas');
                }
                listService.itemSearched = 0;
            }
        }, 500);
        return this;
    }

}


export default BehaviorsPageView;
